var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-create',{attrs:{"name":"form","option":_vm.dataOptions,"rule":_vm.dataRule,"value":_vm.value},on:{"update:value":function($event){_vm.value=$event}},model:{value:(_vm.fApi),callback:function ($$v) {_vm.fApi=$$v},expression:"fApi"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }